import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Modal from 'react-bootstrap/Modal';
import Loader from "../../../shared/Loader/Loader"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddNewInsuranceTypeCode = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance Type')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance Type')?.IsDeleted
    const API_URL = enumUtil.controller.General
    let Diagnosis_Modal = {
        // PracticeID: 113,
        InsuranceTypeCode: "",
        Description: "",
        FullDescription: "",
        UpdatedDate: "",
        UpdatedBy: ""
    }
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        InsuranceTypeCodeVal: "",
    }
    const [InsuranceTypeCodes, setInsuranceTypeCodes] = useState()
    const [InsuranceTypeValidationModal, setInsuranceTypeValidationModal] = useState(ValidationModal)
    const [InsuranceTypeSaveUpdateModal, setInsuranceTypeSaveUpdateModal] = useState({})
    const [mainInsuranceTypeModal, setmainInsuranceTypeModal] = useState(Diagnosis_Modal);
    // const [InsuranceCategoryID, setInsuranceCategoryID] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const { isOpenInsuranceType, onClose, onDeleteDiagnosis, type } = { ...props }
    const [onInsuranceTypeSave, setOnInsuranceTypeSave] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);


    useEffect(() => {
        if (props.InsuranceTypeCode != null) {
            setInsuranceTypeCodes(props.InsuranceTypeCode)
            setDel(true)
        } else {
            if (!onInsuranceTypeSave) {
                setInsuranceTypeCodes(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(InsuranceTypeCodes) && !isNull(InsuranceTypeCodes !== '0')) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": InsuranceTypeCodes,
                "TableName": enumUtil.enumAPITableName.InsuranceType,

            }).then((response) => {
                setIsLoading(false)
                setmainInsuranceTypeModal(response)
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [InsuranceTypeCodes])

    const handleInsuranceTypeChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainInsuranceTypeModal };
        let saveModal = { ...InsuranceTypeSaveUpdateModal }
        modal[name] = value
        setmainInsuranceTypeModal(modal)
        for (var property in Diagnosis_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setInsuranceTypeSaveUpdateModal(saveModal)
    }
    const InsuranceTypeValidation = async () => {
        let ValidationModal = {
            InsuranceTypeCodeVal: FormValidator(
                mainInsuranceTypeModal.InsuranceTypeCode,
                enumUtil.enumValidationType.Length,
                'Code',
                2
            ),
            InsuranceTypeCodeVal: FormValidator(
                mainInsuranceTypeModal.InsuranceTypeCode,
                enumUtil.enumValidationType.Required,
                'Insurance Type Code',
            ),
        }
        await setInsuranceTypeValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveInsuranceType = async () => {
        // setInsuranceTypeCodes(mainInsuranceTypeModal.InsuranceTypeCode)
        // setInsuranceTypeCodes(InsuranceTypeCodes)
        await InsuranceTypeValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setInsuranceTypeSaveUpdateModal(InsuranceTypeSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.InsuranceType,
                ID: InsuranceTypeCodes,
                data: { ...InsuranceTypeSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    // console.log("response", response)
                    setIsLoading(false)
                    if (!isNull(response.id)) {
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setInsuranceTypeCodes(response.id)
                        setOnInsuranceTypeSave(true)
                        onDeleteDiagnosis()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.warning)
                })
        }
    }
    const SetInsuranceTypeName = () => {
        if (mainInsuranceTypeModal.InsuranceTypeCode != null && mainInsuranceTypeModal.InsuranceTypeCode != "") {
            return (
                <p className="heading">{mainInsuranceTypeModal.InsuranceTypeCode}</p>
            )
        } else {
            return (
                <p className="heading">Add New Insurance Type Code</p>
            )
        }
    }

    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className= {IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '}  onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.InsuranceType} ID={InsuranceTypeCodes} onClose={onDeleteDiagnosis} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={InsuranceTypeCodes + ""} TableName={enumUtil.enumAPITableName.InsuranceType} />
    }
    const AddNewInsuranceTypeModalBody = () => {
        return (
            <div>
                <div className="form-group input">
                    <label htmlFor="InsuranceTypeCode">Code<span className='req'>*</span></label>
                    <div className={InsuranceTypeValidationModal.InsuranceTypeCodeVal ? 'form-group input error' : 'form-group input'}>
                        <input type="text"
                            className='form-control'
                            required
                            maxLength={2}
                            name="InsuranceTypeCode"
                            id="InsuranceTypeCode"
                            autoComplete="off"
                            value={mainInsuranceTypeModal.InsuranceTypeCode}
                            onChange={handleInsuranceTypeChange}
                        />
                        {InsuranceTypeValidationModal.InsuranceTypeCodeVal}
                    </div>
                    {/* error helperText="Error Message" */}
                </div>
                <div className='form-group input'>
                    <label htmlFor="Description">Description</label>
                    <input type="text"
                        className='form-control'
                        name="Description"
                        id="Description"
                        autoComplete="off"
                        value={mainInsuranceTypeModal.Description}
                        onChange={handleInsuranceTypeChange}
                    />
                </div>
                <div className='form-group input'>
                    <label htmlFor="FullDescription">Full Description</label>
                    <textarea type="text"
                        rows={10}
                        className='form-control'
                        name="FullDescription"
                        id="FullDescription"
                        autoComplete="off"
                        value={mainInsuranceTypeModal.FullDescription}
                        onChange={handleInsuranceTypeChange}
                    />
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    {AddNewInsuranceTypeModalBody()}
                    <ModalFooter isSaved={onInsuranceTypeSave ? onDeleteDiagnosis : onClose} handleSave={handleSaveInsuranceType} UpdatedDate={mainInsuranceTypeModal.UpdatedDate} UpdatedBy={mainInsuranceTypeModal.UpdatedBy} ID={InsuranceTypeCodes}  IsEditAllowed={IsEditAllowed} />
                </div>
                :
                <Modal show={isOpenInsuranceType} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal" >
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetInsuranceTypeName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onInsuranceTypeSave ? onDeleteDiagnosis : onClose} key={622} Name={'Insurance Type'} />
                        {isLoading ? <Loader /> : null}
                        {AddNewInsuranceTypeModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onInsuranceTypeSave ? onDeleteDiagnosis : onClose} handleSave={handleSaveInsuranceType} UpdatedDate={mainInsuranceTypeModal.UpdatedDate} UpdatedBy={mainInsuranceTypeModal.UpdatedBy} ID={InsuranceTypeCodes}  IsEditAllowed={IsEditAllowed}/>
                </Modal>
            }
        </React.Fragment>
    )
}

export default AddNewInsuranceTypeCode